/**
 * 全局定义事件
 */

import Vuex from '@/store'
import router from '@/router'
import Store from '@/finiteComponents/Layout/LeftNav/store'
import { setMenuAndSubmenu, tabIsInMenus, getUUID } from '@/Tool/index'
import vuex from '@/store'
import { loginOut } from '@/Tool/LoginSet'
// 重新加载设置一级菜单及菜单收缩
window.addEventListener('load', function () {
  // 设置选中一级菜单
  Vuex.state.menus.forEach((item: any) => {
    item.isSelect = item.key === Vuex.state.selectMenu.key
  })
  Vuex.commit('set_data', {
    leftMenuCollapse: true,
    selectMenu: Vuex.state.selectMenu,
    selectSubmenus: Vuex.state.subMenus[Vuex.state.selectMenu.key],
  })
})

// 子系统事件触发，父系统做响应操作
window.addEventListener(
  'OPEN_TAB',
  function (e: any) {
    const url = e.detail.url
    const selectMenu = tabIsInMenus(url)
    let newTab
    if (selectMenu.firstMenu || selectMenu.secondMenu) {
      const index = Vuex.state.tabsArr.findIndex(
        (item) => item.key === selectMenu.firstMenu?.key || item.key === selectMenu.secondMenu?.key,
      )
      newTab = {
        key: selectMenu.secondMenu?.key || selectMenu.firstMenu?.key,
        name: `${e.detail.title}&${selectMenu.secondMenu?.key || selectMenu.firstMenu?.key}`,
        url: e.detail.url,
        isOutside: true,
      }
      if (index < 0) {
        Vuex.state.tabsArr.push(newTab)
      }
      // 如果是对应的一级菜单，就直接选中一级菜单
      if (selectMenu.firstMenu) {
        // 设置选中一级菜单
        Vuex.state.menus.forEach((item: any) => {
          item.isSelect = item.key === selectMenu.firstMenu.key
        })
        Vuex.commit('set_data', {
          selectMenu: selectMenu.firstMenu,
          selectSubmenus: {},
        })
      }
      // 如果是跳转的二级菜单，则选中一级，二级菜单，并打开菜单
      if (selectMenu.secondMenu) {
        setMenuAndSubmenu(selectMenu.secondMenu.parentKey)
        Vuex.commit('set_data', {
          leftMenuCollapse: false,
        })
      }
      Vuex.commit('set_data', {
        activeTabName: `${e.detail.title}&${newTab.key}`,
      })
      Store.store.defaultActive = newTab.key as string
    } else {
      const index = Vuex.state.tabsArr.findIndex((tab) => tab.url === e.detail.url)
      const uuid = getUUID()
      if (index < 0) {
        Vuex.state.tabsArr.push({
          key: uuid,
          name: `${e.detail.title}&${uuid}`,
          url: e.detail.url,
          isOutside: true,
        })
        Vuex.commit('set_data', {
          activeTabName: `${e.detail.title}&${uuid}`,
        })
      } else {
        Vuex.commit('set_data', {
          activeTabName: Vuex.state.tabsArr[index].name,
        })
      }
      Vuex.commit('set_data', {
        selectSubmenus: {},
        leftMenuCollapse: true,
      })
      Store.store.defaultActive = ''
    }
    Vuex.commit('set_data', {
      tabsArr: Vuex.state.tabsArr,
      // 跳转tab关闭二级菜单
      leftMenuCollapse: true,
    })
    router.push({ path: e.detail.url })
  },
  false,
)

// 子系统事件触发，父系统做响应操作
window.addEventListener(
  'UPDATE_TAB',
  function (e: any) {
    const url = e.detail.url
    const oldurl = e.detail.oldurl
    const name = e.detail.title
    const isEdit = e.detail.isEdit
    const message = e.detail.message
    let index
    if (oldurl) {
      index = Vuex.state.tabsArr.findIndex((item) => item.url === oldurl)
    } else {
      index = Vuex.state.tabsArr.findIndex((item) => item.url === url)
    }
    if (index >= 0) {
      const arr = Vuex.state.tabsArr
      const selectTabMenu = tabIsInMenus(url)
      if (selectTabMenu.firstMenu || selectTabMenu.secondMenu) {
        arr[index].name = name
          ? `${name}&${selectTabMenu.secondMenu.key || selectTabMenu.firstMenu.key}`
          : arr[index].name
      } else {
        const uuid = getUUID()
        arr[index].name = name ? `${name}&${uuid}` : arr[index].name
      }
      arr[index].url = url || arr[index].url
      arr[index].isEdit = isEdit || 0
      arr[index].message = message || ''
      Vuex.commit('set_data', {
        tabsArr: arr,
        activeTabName: `${arr[index].name}`,
      })
    }
  },
  false,
)

// 主框架提供关闭tab页签方法
window.addEventListener(
  'MAIN_CLOSE_TAB',
  function (e: any) {
    const url = e.detail.url
    const tabsArrs = vuex.state.tabsArr
    const index = tabsArrs.findIndex((item) => item.url === url)
    const nowTabsArr = tabsArrs.filter((item) => {
      return item.name !== tabsArrs[index].name
    })
    Vuex.commit('set_data', {
      tabsArr: nowTabsArr,
    })
  },
  false,
)

// 主框架提供退出登录并返回登录页方法
window.addEventListener(
  'LOG_OUT',
  function () {
    loginOut(vuex.state.user.orgid as number)
  },
  false,
)

// 存储 config 地址
window.addEventListener(
  'SET_CONFIG',
  function (e: any) {
    const { config } = e.detail
    Vuex.commit('set_data', {
      config,
    })
  },
  false,
)

window.addEventListener(
  'SET_USER',
  function (e: any) {
    const { user } = e.detail
    Vuex.commit('set_data', {
      user: {
        info: {
          ...Vuex.state.user.info,
          ...user,
        },
      },
    })
  },
  false,
)

export interface ITabInterface {
  key?: string
  title: string
  url: string
  parentKey?: string
  child?: any[]
}
// 跳转打开新的tab页签
export function openTab(tabItem: ITabInterface) {
  const event = new CustomEvent('OPEN_TAB', {
    detail: {
      title: tabItem.title,
      url: tabItem.url,
    },
    bubbles: true,
    cancelable: true,
  })
  window.dispatchEvent(event)
}
